import axios from "axios";

interface SignupData {
	// Company Information
	companyName: string;
	companyState?: string; // Made optional - being removed from form
	companyCountry?: string; // Made optional - being removed from form
	griSector: string;
	organizationType: string;

	// Primary Contact Information
	firstName: string;
	lastName: string;
	contactState?: string; // Made optional - being removed from form
	contactCountry?: string; // Made optional - being removed from form
	phone?: string; // Made optional - being removed from form
	mobilePhone?: string; // Already optional - being removed from form
	email: string;
	jobTitle: string;

	// Selected plan from the signup right-panel order summary.
	// Backend persists this into companies.current_plan; defaults to 'starter'.
	plan?: "starter" | "core" | "premium" | "measure" | "enable";
	supplierRequest?: string;

	// Legacy fields (for backward compatibility)
	fullName: string;
	company: string;
	role: string;
	referralSource: string;
	projectDescription?: string;
	auth0Sub: string;
}

interface SignupResponse {
	companyId: string;
	companyName: string;
	artehToken: string;
	demoCompanyId: string;
	demoToken: string;
	message: string;
}

class SignupService {
	private apiUrl: string;

	constructor() {
		this.apiUrl = process.env.REACT_APP_LAMBDA_ARTEH_API_DOMAIN || "";
	}

	/**
	 * Submit signup form to create company and user
	 */
	async signup(
		data: SignupData,
		accessToken: string,
	): Promise<SignupResponse> {
		try {
			const response = await axios.post(
				`${this.apiUrl}/api/signup`,
				data,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${accessToken}`,
					},
				},
			);

			// The backend wraps response in { Ok: true, Data: {...} }
			return response.data.Data;
		} catch (error: any) {
			console.error("Signup error:", error);
			console.error("Error response:", error.response?.data);

			if (error.response?.status === 409) {
				throw new Error("Company already exists");
			}

			if (error.response?.status === 400) {
				// Return the actual error message from the backend
				const errorMessage =
					error.response?.data?.message ||
					error.response?.data?.error ||
					"Invalid form data. Please check all required fields.";
				throw new Error(errorMessage);
			}

			throw new Error(
				error.response?.data?.message || "Failed to register company",
			);
		}
	}
}

const signupService = new SignupService();
export default signupService;
